export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4051e2e10ee737cedb7dd2865d1908a4c322ae6fe2&name=revalidateCommunity!'